import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faAngleUp,
  faArrowDown,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import { Modal, Button } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import {
  periodOneMileStoneNames,
  periodOtherMilestoneNames,
} from "../../constants";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
import { formatTwoDecimal } from "../../utils/index";
class CAMDepositDetails extends React.Component {
  countError = "";
  state = {
    readOnEdit: false,
    currentIndex: null,
    disableOnEdit: false,
    applicableValue: "",
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    index_val: "",
    delete: false,
    keyvalue: "",
    leaseCommencementDate: "",
    popupData: {},
    isOpen: false,
    milestoneMonths: "CDEP Milestone # Months",
    showForm: true,
    fromDate: "",
    toDate: "",
    leaseTermDD: "",
    leaseTermMM: "",
    leaseTermYY: "",
    periodTermDD: "",
    periodTermMM: "",
    periodTermYY: "",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    period: 1,
    redirect: false,
    milestonesCount: 1,
    milestones: [],
    milestoneNamesValues: [],
    initialValues: {
      cdepLogic: {
        milestones: [],
        period: "",
        camDepositNature: "",
        months: "",
        fromDate: "",
        toDate: "",
        rateUOM: "",
        onArea: "",
        milestonesCount: 0,
        totalAmount: "",
        rate: "",
      },
    },
    camDepositDetails: [],
    toggleCdForm: false,
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!", // will override all messages
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.applicableValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  showCdForm = (e) => {
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (e.target.value === "yes") {
      this.setState({
        toggleCdForm: true,
      });
    } else {
      this.setState({
        toggleCdForm: false,
      });
    }
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  componentDidMount() {

    let athis=this;
    axios({
      url:`${apiUrl.apiUrl.url}/create-lease/fetch-lease-cam-deposit-details?id=${this.props.match.params.id}`,
      method: "GET",
    }).then(function(response){
      let data = response.data;
      athis.state.applicableValue = data.camDepositApplicable;
      athis.state.fromDate = data.from;
      athis.state.leaseCommencementDate = data.lcd;
      athis.state.renewalLeaseTermYY = data.renewalLeaseTermYY;
      athis.state.renewalLeaseTermDD = data.renewalLeaseTermDD;
      athis.state.renewalLeaseTermMM = data.renewalLeaseTermMM;

      if (data.camDepositDetails.length > 0) {
        // let _tempDate = new Date(
        //   data.camDepositDetails[data.camDepositDetails.length - 1].toDate
        // );
        // _tempDate.setDate(_tempDate.getDate() + 1);
        // var dd = ("0" + _tempDate.getDate()).slice(-2);
        // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
        // var y = _tempDate.getFullYear();
        // var someFormattedDate = y + "-" + mm + "-" + dd;
        // athis.state.fromDate = someFormattedDate;
        athis.setState({
          fromDate: getToDate(
            data.camDepositDetails[data.camDepositDetails.length - 1].toDate,
            2,
            0,
            0
          ),
        });
      }
      if (data.camDepositApplicable === "yes") {
        athis.setState({
          toggleCdForm: true,
        });
      } else {
        athis.setState({
          toggleCdForm: false,
        });
      }
      athis.setState({
        initialValues: data,
        camDepositDetails: data.camDepositDetails,
        leaseTermDD: data.leaseTermDD,
        leaseTermMM: data.leaseTermMM,
        leaseTermYY: data.leaseTermYY,
        notes_12: data.notes_12,
        period:
          data.camDepositDetails.length > 0
            ? data.camDepositDetails.length + 1
            : 1,
      });
      var _intialValues = athis.state.initialValues;
      _intialValues.cdepLogic = {
        milestones: [
          {
            dueDate: "",
            milestoneName: "",
            amount: "",
            milestonePercent: "",
          },
        ],
        period: "",
        camDepositNature: "",
        months: "",
        fromDate: "",
        toDate: "",
        rateUOM: "",
        onArea: "",
        milestonesCount: 0,
        totalAmount: "",
        rate: "",
      };
      if (
        data.camDepositDetails[data.camDepositDetails.length - 1].toDate ==
        data.to
      ) {
        athis.setState({
          showForm: false,
        });
      }
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-cam-deposit-details?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.state.applicableValue = data.camDepositApplicable;
    //     this.state.fromDate = data.from;
    //     this.state.leaseCommencementDate = data.lcd;
    //     this.state.renewalLeaseTermYY = data.renewalLeaseTermYY;
    //     this.state.renewalLeaseTermDD = data.renewalLeaseTermDD;
    //     this.state.renewalLeaseTermMM = data.renewalLeaseTermMM;

    //     if (data.camDepositDetails.length > 0) {
    //       // let _tempDate = new Date(
    //       //   data.camDepositDetails[data.camDepositDetails.length - 1].toDate
    //       // );
    //       // _tempDate.setDate(_tempDate.getDate() + 1);
    //       // var dd = ("0" + _tempDate.getDate()).slice(-2);
    //       // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
    //       // var y = _tempDate.getFullYear();
    //       // var someFormattedDate = y + "-" + mm + "-" + dd;
    //       // this.state.fromDate = someFormattedDate;
    //       this.setState({
    //         fromDate: getToDate(
    //           data.camDepositDetails[data.camDepositDetails.length - 1].toDate,
    //           2,
    //           0,
    //           0
    //         ),
    //       });
    //     }
    //     if (data.camDepositApplicable === "yes") {
    //       this.setState({
    //         toggleCdForm: true,
    //       });
    //     } else {
    //       this.setState({
    //         toggleCdForm: false,
    //       });
    //     }
    //     this.setState({
    //       initialValues: data,
    //       camDepositDetails: data.camDepositDetails,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //       notes_12: data.notes_12,
    //       period:
    //         data.camDepositDetails.length > 0
    //           ? data.camDepositDetails.length + 1
    //           : 1,
    //     });
    //     var _intialValues = this.state.initialValues;
    //     _intialValues.cdepLogic = {
    //       milestones: [
    //         {
    //           dueDate: "",
    //           milestoneName: "",
    //           amount: "",
    //           milestonePercent: "",
    //         },
    //       ],
    //       period: "",
    //       camDepositNature: "",
    //       months: "",
    //       fromDate: "",
    //       toDate: "",
    //       rateUOM: "",
    //       onArea: "",
    //       milestonesCount: 0,
    //       totalAmount: "",
    //       rate: "",
    //     };
    //     if (
    //       data.camDepositDetails[data.camDepositDetails.length - 1].toDate ==
    //       data.to
    //     ) {
    //       this.setState({
    //         showForm: false,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  calculateToDate() {
    this.setState({
      toDate: getToDate(
        this.state.fromDate,
        this.state.periodTermDD,
        this.state.periodTermMM,
        this.state.periodTermYY
      ),
    });
  }

  getDepositNature(e, values, setFieldValue) {
    if (
      this.state.camDepositDetails[e.target.value] !== undefined &&
      this.state.camDepositDetails[e.target.value].length > 0 &&
      this.state.camDepositDetails[e.target.value][
        this.state.camDepositDetails[e.target.value].length - 1
      ].toDate == values.to
    ) {
      setFieldValue("rdepLogic.rentDepositNature", "");
      // alert("Values For this type has completed the period");
      this.setState({
        popupalertMessage: true,
        popupMessageContent: "Values For this type has completed the period",
      });
      return false;
    }
    var _camDepositDetails = this.state.camDepositDetails;
    if (
      _camDepositDetails[e.target.value] == undefined ||
      _camDepositDetails[e.target.value].length == 0
    ) {
      this.state.fromDate = values.from;
      this.state.toDate = "";
      this.state.period = 1;
    } else {
      this.state.fromDate = getToDate(
        _camDepositDetails[e.target.value][
          _camDepositDetails[e.target.value].length - 1
        ].toDate,
        2,
        0,
        0
      );
      this.state.toDate = "";
      this.state.period =
        this.state.camDepositDetails[e.target.value].length + 1;
    }
    this.setState({});
    if (this.state.period == "1") {
      this.setState({
        milestoneNamesValues: periodOneMileStoneNames,
      });
    } else {
      this.setState({
        milestoneNamesValues: periodOtherMilestoneNames,
      });
    }
    return true;
  }

  editCd(index, values, key) {
    console.log(values);
    this.state.currentIndex = index;
    this.state.disableOnEdit = true;
    this.state.readOnEdit = true;
    console.log(key, index);
    console.log(this.state.camDepositDetails);
    this.state.period = this.state.camDepositDetails[key][index].period;
    if (this.state.camDepositDetails[key][index].period == "1") {
      this.setState({
        milestoneNamesValues: periodOneMileStoneNames,
      });
    } else {
      this.setState({
        milestoneNamesValues: periodOtherMilestoneNames,
      });
    }
    this.setState({
      showForm: true,
      showAddBtn: true,
      periodTermDD: this.state.camDepositDetails[key][index].periodTermDD,
      periodTermMM: this.state.camDepositDetails[key][index].periodTermMM,
      periodTermYY: this.state.camDepositDetails[key][index].periodTermYY,
    });
    // values.rdepLogic = this.state.camDepositDetails[key][index];
    this.state.milestonesCount =
      this.state.camDepositDetails[key][index].milestones.length;
    this.state.fromDate = this.state.camDepositDetails[key][index].fromDate;
    this.state.toDate = this.state.camDepositDetails[key][index].toDate;
    values.cdepLogic.camDepositNature =
      this.state.camDepositDetails[key][index].camDepositNature;
    values.cdepLogic.months = this.state.camDepositDetails[key][index].months;
    values.cdepLogic.rateUOM = this.state.camDepositDetails[key][index].rateUOM;
    values.cdepLogic.rate = this.state.camDepositDetails[key][index].rate;
    values.cdepLogic.totalAmount =
      this.state.camDepositDetails[key][index].totalAmount;

    for (
      let i = 0;
      i < this.state.camDepositDetails[key][index].milestones.length;
      i++
    ) {
      // if (this.state.milestones === undefined) {
      this.state.milestones[i] = {};
      values.cdepLogic.milestones[i] = {};
      this.state.milestones[i].milestoneName =
        this.state.camDepositDetails[key][index].milestones[i].milestoneName;
      values.cdepLogic.milestones[i].milestoneName =
        this.state.camDepositDetails[key][index].milestones[i].milestoneName;
      this.state.milestones[i].dueDate =
        this.state.camDepositDetails[key][index].milestones[i].dueDate;
      values.cdepLogic.milestones[i].dueDate =
        this.state.camDepositDetails[key][index].milestones[i].dueDate;
      this.state.milestones[i].milestonePercent =
        this.state.camDepositDetails[key][index].milestones[i].milestonePercent;
      values.cdepLogic.milestones[i].milestonePercent =
        this.state.camDepositDetails[key][index].milestones[i].milestonePercent;
      this.state.milestones[i].amount =
        this.state.camDepositDetails[key][index].milestones[i].amount;
      values.cdepLogic.milestones[i].amount =
        this.state.camDepositDetails[key][index].milestones[i].amount;
      if (
        this.state.camDepositDetails[key][index].milestones[i].milestoneType !=
        undefined
      ) {
        this.state.milestones[i].milestoneType =
          this.state.camDepositDetails[key][index].milestones[i].milestoneType;
        values.cdepLogic.milestones[i].milestoneType =
          this.state.camDepositDetails[key][index].milestones[i].milestoneType;
      }
      if (
        this.state.camDepositDetails[key][index].milestones[
          i
        ].milestoneName.includes("Escalation")
      ) {
        this.state.milestones[i].milestoneQuantityType = "CDEP Milestone %";
        values.cdepLogic.milestones[i].milestoneQuantityType =
          "CDEP Milestone %";
      } else {
        this.state.milestones[i].milestoneQuantityType =
          "CDEP Milestone # Months";
        values.cdepLogic.milestones[i].milestoneQuantityType =
          "CDEP Milestone # Months";
      }
      this.setState({});
      // }
    }

    this.setState({});
  }

  addDetails = (values, resetForm) => {
    if (this.state.currentIndex === null) {
      if (!this.validator.allValid()) {
        console.log(this.validator);
        this.validator.showMessages();
        return false;
      }
      var totalMilestoneAmount = 0;
      for (let i = 0; i < values.cdepLogic.milestones.length; i++) {
        totalMilestoneAmount += Number(this.state.milestones[i].amount);
      }
      if (this.state.period == "1") {
        if (formatTwoDecimal(totalMilestoneAmount) != formatTwoDecimal(values.cdepLogic.totalAmount)  ) {
          this.setState({
            popupalertMessage: true,
            popupMessageContent:
              "Total Amount of Milestones do not match with total amount of period",
          });
          return false;
        }
      } else {
        var previousAmount =
          this.state.camDepositDetails[values.cdepLogic.camDepositNature][
            this.state.camDepositDetails[values.cdepLogic.camDepositNature]
              .length - 1
          ].totalAmount;
        var currentAmount = values.cdepLogic.totalAmount;
        var balanceAmount = currentAmount - previousAmount;
        console.log(previousAmount, currentAmount, balanceAmount);
        for (let i = 0; i < values.cdepLogic.milestones.length; i++) {
          if (this.state.period > 1) {
            values.cdepLogic.milestones[i].milestoneType = "CDEP Percent";
            this.setState({});
          }
        }
      }

      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        return false;
      }
      var _camDepositDetails = this.state.camDepositDetails;
      values.cdepLogic.period = this.state.period;
      values.cdepLogic.fromDate = this.state.fromDate;
      values.cdepLogic.toDate = this.state.toDate;
      values.cdepLogic.periodTermYY = this.state.periodTermYY;
      values.cdepLogic.periodTermMM = this.state.periodTermMM;
      values.cdepLogic.periodTermDD = this.state.periodTermDD;

      if (_camDepositDetails[values.cdepLogic.camDepositNature] == undefined) {
        _camDepositDetails[values.cdepLogic.camDepositNature] = [];
      }
      _camDepositDetails[values.cdepLogic.camDepositNature].push({
        ...values.cdepLogic,
      });
      this.setState({
        camDepositDetails: _camDepositDetails,
      });

      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      this.state.period++;
      values.cdepLogic.rate = "";
      this.state.milestonesCount = 1;
      this.state.milestones = [];
      values.cdepLogic.milestones = [];
      values.cdepLogic.escalationPercent = '';
      values.cdepLogic.totalAmount = '';

      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      this.validator.hideMessages();
      if (this.state.period == "1") {
        this.setState({
          milestoneNamesValues: periodOneMileStoneNames,
        });
      } else {
        this.setState({
          milestoneNamesValues: periodOtherMilestoneNames,
        });
      }
      // this.state.milestones = [];
    } else {
      if (!this.validator.allValid()) {
        console.log(this.validator);
        this.validator.showMessages();
        return false;
      }
      var totalMilestoneAmount = 0;
      for (let i = 0; i < values.cdepLogic.milestones.length; i++) {
        totalMilestoneAmount += Number(this.state.milestones[i].amount);
      }
      if (this.state.period == "1") {
        if (formatTwoDecimal(totalMilestoneAmount) != formatTwoDecimal(values.cdepLogic.totalAmount)) {
          // alert(
          //   "Total Amount of Milestones do not match with total amount of period"
          // );
          this.setState({
            popupalertMessage: true,
            popupMessageContent:
              "Total Amount of Milestones do not match with total amount of period",
          });

          return false;
        }
      } else {
        var previousAmount =
          this.state.camDepositDetails[values.cdepLogic.camDepositNature][
            this.state.camDepositDetails[values.cdepLogic.camDepositNature]
              .length - 1
          ].totalAmount;
        var currentAmount = values.cdepLogic.totalAmount;
        var balanceAmount = currentAmount - previousAmount;
        console.log(previousAmount, currentAmount, balanceAmount);
        for (let i = 0; i < values.cdepLogic.milestones.length; i++) {
          if (this.state.period > 1) {
            values.cdepLogic.milestones[i].milestoneType = "CDEP Percent";
            this.setState({});
          }
        }
      }

      if (this.state.toDate > values.to) {
        // alert("Enter a date less than " + values.to);
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        return false;
      }
      var _camDepositDetails = this.state.camDepositDetails;
      values.cdepLogic.period = this.state.period;
      values.cdepLogic.fromDate = this.state.fromDate;
      values.cdepLogic.toDate = this.state.toDate;
      values.cdepLogic.periodTermYY = this.state.periodTermYY;
      values.cdepLogic.periodTermMM = this.state.periodTermMM;
      values.cdepLogic.periodTermDD = this.state.periodTermDD;

      if (_camDepositDetails[values.cdepLogic.camDepositNature] == undefined) {
        _camDepositDetails[values.cdepLogic.camDepositNature] = [];
      }
      _camDepositDetails[values.cdepLogic.camDepositNature][
        this.state.currentIndex
      ] = { ...values.cdepLogic };

      _camDepositDetails[values.cdepLogic.camDepositNature][
        this.state.currentIndex
      ].milestones = this.state.milestones;
      this.setState({
        camDepositDetails: _camDepositDetails,
      });

      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      this.state.period++;
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      // this.state.milestonesCount = 1;
      // resetForm();
      this.validator.hideMessages();
      // this.state.milestones = [];
      // values.cdepLogic.camDepositNature = "";
      this.state.disableOnEdit = false;
      this.state.currentIndex = null;
      this.state.readOnEdit = false;
      this.setState({});
    }
  };

  resetDetails = (values, resetForm) => {
    this.state.periodTermDD = 0;
    this.state.periodTermMM = 0;
    this.state.periodTermYY = 0;
    this.state.fromDate = "";
    this.state.toDate = "";
    this.state.period = "";
    this.state.milestonesCount = 1;
    resetForm();
    this.validator.hideMessages();
    this.state.milestones = [];
    values.cdepLogic.camDepositNature = "";
    this.state.disableOnEdit = false;
    this.state.currentIndex = null;
    this.state.readOnEdit = false;
    this.setState({});
  };

  calculateCdepAmount(values, setFieldValue) {
    if (values.cdepLogic.rateUOM == "Flat Amount") {
      values.cdepLogic.totalAmount =
         formatTwoDecimal(Number(values.cdepLogic.rate) * Number(values.cdepLogic.months));
      setFieldValue(
        "cdepLogic.totalAmount",
        formatTwoDecimal(Number(values.cdepLogic.rate) * Number(values.cdepLogic.months))
      );  
    } else if (
      values.cdepLogic.rateUOM == "Per Sq Ft" &&
      values.cdepLogic.onArea == "Carpet Area"
    ) {
      values.cdepLogic.totalAmount =
         formatTwoDecimal(Number(values.cdepLogic.rate) *
        Number(values.totalCarpetArea) *
        Number(values.cdepLogic.months));
      setFieldValue(
        "cdepLogic.totalAmount",
        formatTwoDecimal(Number(values.cdepLogic.rate) *
        Number(values.totalCarpetArea) *
        Number(values.cdepLogic.months))
      );
    } else if (
      values.cdepLogic.rateUOM == "Per Sq Ft" &&
      values.cdepLogic.onArea == "Usable Area"
    ) {
      values.cdepLogic.totalAmount =
        formatTwoDecimal(Number(values.cdepLogic.rate) *
        Number(values.totalUsableArea) *
        Number(values.cdepLogic.months));
      setFieldValue(
        "cdepLogic.totalAmount",
        formatTwoDecimal(Number(values.cdepLogic.rate) *
        Number(values.totalUsableArea) *
        Number(values.cdepLogic.months))
      );
    } else if (
      values.cdepLogic.rateUOM == "Per Sq Ft" &&
      values.cdepLogic.onArea == "Gross Leasable Area"
    ) {
      values.cdepLogic.totalAmount =
        formatTwoDecimal(Number(values.cdepLogic.rate) *
        Number(values.totalGrossLeasableArea) *
        Number(values.cdepLogic.months));
      setFieldValue(
        "cdepLogic.totalAmount",
        formatTwoDecimal(Number(values.cdepLogic.rate) *
        Number(values.totalGrossLeasableArea) *
        Number(values.cdepLogic.months))
      );
    }
    if (this.state.period > 1) {
      this.calculateMilestoneAmount(1, values, 0);
    }
    if(values.cdepLogic.totalAmount > 0){
      this.calculateEscalationPercentage(values, setFieldValue, (values.cdepLogic.totalAmount/values.cdepLogic.months));
    }
  }

  calculateEscalationPercentage(values, setFieldValue, currentRecord) {
    if ( typeof this.state.camDepositDetails[values.cdepLogic.camDepositNature] != "undefined" && this.state.camDepositDetails[values.cdepLogic.camDepositNature].length > 0) {
      let count = this.state.camDepositDetails[values.cdepLogic.camDepositNature].length;
      let prevMonth = parseFloat(this.state.camDepositDetails[values.cdepLogic.camDepositNature][count - 1]['months']);
      let prevRecord = this.state.camDepositDetails[values.cdepLogic.camDepositNature][count - 1]['totalAmount']/prevMonth;
      let percent = ((currentRecord-prevRecord)/prevRecord)*100;
      setFieldValue(
        "cdepLogic.escalationPercent",
        (
          percent
        ).toFixed(2)
      );
    }
  }

  changeFieldName(e, id, values) {
    console.log(values);
    if (e.target.value == "Due on Lease Commencement Date") {
      this.state.milestones[id].dueDate = this.state.leaseCommencementDate;
      values.cdepLogic.milestones[id].dueDate =
        this.state.leaseCommencementDate;
    } else {
      this.state.milestones[id].dueDate = "";
      // values.cdepLogic.milestones[id].dueDate = "";
    }
    if (e.target.value.includes("Escalation")) {
      this.state.milestones[id].milestoneQuantityType = "CDEP Milestone %";
    } else {
      this.state.milestones[id].milestoneQuantityType =
        "CDEP Milestone # Months";
    }
  }

  changeMilestonePercentName(e, id, values) {
    if (e.target.value == "CDEP Months") {
      this.state.milestones[id].milestoneQuantityType =
        "CDEP Milestone # Months";
    } else if (e.target.value == "CDEP Percent") {
      this.state.milestones[id].milestoneQuantityType = "CDEP Milestone %";
    } else {
      this.state.milestones[id].milestoneQuantityType = "";
    }


    if (e.target.value == "CDEP Months") {
      this.state.milestones[id].amount =
        (values.cdepLogic.totalAmount / values.cdepLogic.months) *
        Number(this.state.milestones[id].milestonePercent);
      values.cdepLogic.milestones[id].amount = this.state.milestones[id].amount;
      this.setState({});
    } else if (e.target.value == "CDEP Percent") {
      var previousAmount = 0;
      if (
        this.state.camDepositDetails[values.cdepLogic.rentDepositNature] ==
        undefined
      ) {
        previousAmount = 0;
      } else {
        previousAmount =
          this.state.camDepositDetails[values.cdepLogic.rentDepositNature][
            this.state.camDepositDetails[values.cdepLogic.rentDepositNature]
              .length - 1
          ].totalAmount;
      }

      var currentAmount = values.cdepLogic.totalAmount;
      var balanceAmount = currentAmount - previousAmount;
      this.state.milestones[id].amount =
        (balanceAmount / 100) * this.state.milestones[id].milestonePercent;
      values.cdepLogic.milestones[id].amount = this.state.milestones[id].amount;
      this.setState({});
    }
  }

  calculateRentRate(e, values, setFieldValue) {
    console.log(values, "values 672 ");
    console.log(this.state.camDepositDetails, "cam details")
    console.log(values.cdepLogic.camDepositNature, "values.cdepLogic.camDepositNature")


    if (e.target.value > 0 && typeof this.state.camDepositDetails[values.cdepLogic.camDepositNature] != "undefined" && this.state.camDepositDetails[values.cdepLogic.camDepositNature].length > 0) {
      let count = this.state.camDepositDetails[values.cdepLogic.camDepositNature].length;
      let prevMonth = parseFloat(this.state.camDepositDetails[values.cdepLogic.camDepositNature][count - 1]['months']);
      let prevRecord = this.state.camDepositDetails[values.cdepLogic.camDepositNature][count - 1]['totalAmount']/prevMonth;
console.log(this.state.camDepositDetails[values.cdepLogic.camDepositNature][count - 1], "chekcing")
      let reviseTotalAmt = Number(prevRecord) + Number((prevRecord * e.target.value) / 100);

      console.log(prevRecord, "==", reviseTotalAmt)

      console.log(values.cdepLogic, "new values")

      let currentMonths = parseFloat(values.cdepLogic.months);

      let newRate = 0;
      if (values.cdepLogic.rateUOM == "Per Sq Ft" && values.cdepLogic.onArea == "Gross Leasable Area") {
        newRate = (reviseTotalAmt / values.totalGrossLeasableArea)
      } else if (values.cdepLogic.rateUOM == "Per Sq Ft" && values.cdepLogic.onArea == "Usable Area") {
        newRate = (reviseTotalAmt / values.totalUsableArea)
      } else if (values.cdepLogic.rateUOM == "Per Sq Ft" && values.cdepLogic.onArea == "Carpet Area") {
        newRate = (reviseTotalAmt / values.totalCarpetArea)
      } else {
        let rateVal = reviseTotalAmt - (reviseTotalAmt - prevRecord)
        newRate = rateVal + ((rateVal * e.target.value / 100))
      }

      setFieldValue(
        "cdepLogic.rate",
        (
          newRate
        ).toFixed(2)
      );

      setFieldValue(
        "cdepLogic.totalAmount",
        (
          reviseTotalAmt * currentMonths
        ).toFixed(2)
      );
    }
  }

  calculateMilestoneAmount(e, values, id) {
    if (this.state.period == "1") {
      if (values.cdepLogic.milestones[id].milestoneType == "CDEP Months") {
        this.state.milestones[id].amount =
          (values.cdepLogic.totalAmount / values.cdepLogic.months) *
          Number(this.state.milestones[id].milestonePercent);
        values.cdepLogic.milestones[id].amount =
          this.state.milestones[id].amount;
      } else {
        this.state.milestones[id].amount =
          (values.cdepLogic.totalAmount *
            Number(this.state.milestones[id].milestonePercent)) /
          100;
        values.cdepLogic.milestones[id].amount =
          this.state.milestones[id].amount;
      }
      this.setState({});
    } else {
      var previousAmount =
        this.state.camDepositDetails[values.cdepLogic.camDepositNature][
          this.state.camDepositDetails[values.cdepLogic.camDepositNature]
            .length - 1
        ].totalAmount;
      var currentAmount = values.cdepLogic.totalAmount;
      var balanceAmount = currentAmount - previousAmount;
      this.state.milestones[id].amount = (balanceAmount / 100) * 100;
      values.cdepLogic.milestones[id].amount = this.state.milestones[id].amount;
      this.setState({});
    }
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToDelete = () => {
    var _cdd = this.state.camDepositDetails;
    _cdd[this.state.keyvalue].splice(this.state.index_val, 1);
    this.setState({
      camDepositDetails: _cdd,
      showForm: true,
    });
    this.state.period--;
    this.setState({
      delete: false,
      index_val: "",
      keyvalue: "",
    });
  };
  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  milestoneTabs(handleChange, values) {
    var heads = [];
    for (var i = 0; i < this.state.milestonesCount; i++) {
      heads.push(<Tab>CDEP Milestone {i + 1}</Tab>);
    }

    var body = [];
    for (var i = 0; i < this.state.milestonesCount; i++) {
      if (
        typeof this.state.milestones[i] === "undefined" ||
        this.state.milestones[i] === null
      ) {
        this.state.milestones[i] = {};
        this.state.milestones[i].milestoneName = "";
        this.state.milestones[i].dueDate = "";
        this.state.milestones[i].milestonePercent =
          this.state.period == 1 ? "" : 100;
        this.state.milestones[i].amount = "";
        this.state.milestones[i].milestoneQuantityType =
          "CDEP Milestone # Months";
        this.state.milestones[i].milestoneType = "";
        values.cdepLogic.milestones[i] = {};
        values.cdepLogic.milestones[i].milestoneName = "";
        values.cdepLogic.milestones[i].dueDate = "";
        values.cdepLogic.milestones[i].milestonePercent =
          this.state.period == 1 ? "" : 100;
        values.cdepLogic.milestones[i].amount = "";
        values.cdepLogic.milestones[i].milestoneType = "";
      }
      body.push(
        <TabPanel>
          <div className="newGridSectionForFormMain">
            <div className="newGridSectionInner">
              {/* Milestone Name */}
              <label>
                CDEP Milestone Name <span className="astrik">*</span>
              </label>
              <div className="position-relative">
                <select
                  param={i}
                  name={"cdepLogic.milestones[" + i + "].milestoneName"}
                  value={this.state.milestones[i].milestoneName}
                  onChange={(e) => {
                    var id = e.target.getAttribute("param");
                    this.state.milestones[id].milestoneName = e.target.value;
                    this.changeFieldName(e, id, values);
                    handleChange(e);
                  }}
                >
                  <option value="" label="Select" defaultValue />
                  {this.state.milestoneNamesValues.map((item) => (
                    <option key={"milestoneNamesValues" + item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {this.validator.message(
                  "Milestone Name",
                  this.state.milestones[i].milestoneName,
                  "required",
                  { className: "text-danger" }
                )}
              </div>
            </div>

            <div className="newGridSectionInner">
              {/* Due Date */}
              <label>
                Due Date <span className="astrik">*</span>
              </label>
              <div className="position-relative">
                <Field
                  type="date"
                  param={i}
                  value={this.state.milestones[i].dueDate}
                  name={"cdepLogic.milestones[" + i + "].dueDate"}
                  onChange={(e) => {
                    var id = e.target.getAttribute("param");
                    this.state.milestones[id].dueDate = e.target.value;
                    handleChange(e);
                  }}
                />
                {this.validator.message(
                  "Due Date",
                  this.state.milestones[i].dueDate,
                  "required",
                  { className: "text-danger" }
                )}
              </div>
            </div>

            {this.state.period == "1" && (
              <div className="newGridSectionInner">
                {/* Milestone Type */}
                <label>
                  Milestone Type <span className="astrik">*</span>
                </label>
                <div className="position-relative">
                  <select
                    param={i}
                    value={this.state.milestones[i].milestoneType}
                    name={"cdepLogic.milestones[" + i + "].milestoneType"}
                    onChange={(e) => {
                      var id = e.target.getAttribute("param");
                      this.state.milestones[id].milestoneType = e.target.value;
                      this.changeMilestonePercentName(e, id, values);
                      handleChange(e);
                    }}
                  >
                    <option value="" label="Select" defaultValue />
                    <option value="CDEP Months" label="CDEP Months" />
                    <option value="CDEP Percent" label="CDEP Percent" />
                    <option value="Flat Amount" label="Flat Amount" />
                  </select>
                  {this.validator.message(
                    "Milestone Type",
                    this.state.milestones[i].milestoneType,
                    "required",
                    { className: "text-danger" }
                  )}
                </div>
              </div>
            )}

            {this.state.milestones[i].milestoneType != "Flat Amount" && (
              <div className="newGridSectionInner">
                {/* Milestone Percent or Amount */}
                <label>
                  {this.state.milestones[i].milestoneType == "CDEP Months"
                    ? "CDEP Milestone # Months"
                    : "CDEP Milestone %"}
                </label>
                <div className="position-relative">
                  <Field
                    param={i}
                    type="text"
                    name={"cdepLogic.milestones[" + i + "].milestonePercent"}
                    value={
                      this.state.period === 1
                        ? this.state.milestones[i].milestonePercent
                        : 100
                    }
                    readOnly={this.state.period === 1 ? false : true}
                    onChange={(e) => {
                      var id = e.target.getAttribute("param");
                      this.state.milestones[id].milestonePercent = e.target.value;
                      handleChange(e);
                    }}
                    onBlur={(e) => {
                      var id = e.target.getAttribute("param");
                      this.calculateMilestoneAmount(e, values, id);
                    }}
                  />
                </div>
              </div>
            )}

            <div className="newGridSectionInner">
              {/* Milestone Amount */}
              <label>
                CDEP Milestone Amount (Rs.) <span className="astrik">*</span>
              </label>
              <div className="position-relative">
                <Field
                  type="text"
                  name={"cdepLogic.milestones[" + i + "].amount"}
                  param={i}
                  value={this.state.milestones[i].amount}
                  onChange={(e) => {
                    var id = e.target.getAttribute("param");
                    this.state.milestones[id].amount = e.target.value;
                    handleChange(e);
                  }}
                />
                <ErrorMessage
                  name={"cdepLogic.milestones[" + i + "].amount"}
                  component="div"
                  className="text-red"
                />
              </div>
            </div>
          </div>
        </TabPanel>
      );
    }

    return (
      <div>
        <Tabs>
          <TabList>{heads}</TabList>
          <div>{body}</div>
        </Tabs>
      </div>
    );
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={
            "/createlease/other-deposit-details/" + this.props.match.params.id
          }
        />
      );
    }
    return (
      <div
        className="parentContainer createLease"

      >
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Security Deposit Details</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">CAM Deposit Details</a>
                  </li>
                </ul>
              </div>
            </div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                values.camDepositApplicable = this.state.applicableValue;
                if (!this.applicableValidator.allValid()) {
                  this.applicableValidator.showMessages();
                  return false;
                }
                // if (this.state.camDepositDetails.length == 0) {
                //   this.mainFormValidator.showMessages("countError");
                //   return false;
                // }
                let count = 0;
                for (var key in this.state.camDepositDetails) {
                  count = 1;
                  break;
                }
                if (count == 0 && this.state.applicableValue !== "no") {
                  this.mainFormValidator.showMessages("countError");
                  return false;
                }
                var camDepositDetails = { ...this.state.camDepositDetails };
                values.camDepositDetails = camDepositDetails;
                console.log(this.state.camDepositDetails, "pp");
                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-lease-cam-deposit-details?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
                resetForm,
                setFieldValue,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off" className="customTabs">
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">
                          {this.state.showForm && (
                            <>
                              <div className="newGridSectionInner">
                                <label>
                                  Lease Term (YY-MM-DD) <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <div className="row m-0">
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermYY}
                                      />

                                    </div>
                                    <div className="col-sm-4">
                                      <Field
                                        type="text"
                                        name="leaseTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermMM}
                                      />

                                    </div>
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermDD}
                                      />

                                    </div>
                                  </div>
                                  <ErrorMessage
                                    name="leaseTerm"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  Lease Renewal Term (YY-MM-DD) <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <div className="row m-0">
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermYY}
                                      />

                                    </div>
                                    <div className="col-sm-4">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermMM}
                                      />

                                    </div>
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermDD}
                                      />

                                    </div>
                                  </div>
                                  <ErrorMessage
                                    name="leaseRenewalTerm"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  From
                                </label>
                                <div className="position-relative">
                                  <Field type="date" name="from" />
                                  <ErrorMessage
                                    name="from"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  To
                                </label>
                                <div className="position-relative">
                                  <Field type="date" name="to" />
                                  <ErrorMessage
                                    name="to"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  CAM Deposit Applicable <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name="camDepositApplicable"
                                    value={this.state.applicableValue}
                                    onChange={(e) => {
                                      this.state.applicableValue = e.target.value;
                                      this.showCdForm(e);
                                      handleChange(e);
                                    }}
                                  >
                                    <option value="" label="Select" defaultValue />
                                    <option value="yes" label="Yes" />
                                    <option value="no" label="No" />
                                  </Field>
                                  {this.applicableValidator.message(
                                    "CAM Deposit Applicable",
                                    this.state.applicableValue,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>

                              {this.state.toggleCdForm && (
                                <>
                                  <div className="gridColOneByThree">
                                    <div className="newGridSectionInner newGridSectionInnerForLogin">
                                      <label>
                                        CAM Deposit Nature (CDEP)
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name={"cdepLogic.camDepositNature"}
                                          disabled={this.state.disableOnEdit}
                                          onChange={(e) => {
                                            if (
                                              this.getDepositNature(
                                                e,
                                                values,
                                                setFieldValue
                                              )
                                            ) {
                                              handleChange(e);
                                            }
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Refundable - Interest Free"
                                            label="Refundable - Interest Free"
                                          />
                                          <option
                                            value="Refundable - Interest Bearing"
                                            label="Refundable - Interest Bearing"
                                          />
                                          <option
                                            value="Non Refundable - Interest Free"
                                            label="Non Refundable - Interest Free"
                                          />
                                          <option
                                            value="Non Refundable - Interest Bearing"
                                            label="Non Refundable - Interest Bearing"
                                          />
                                        </Field>
                                        {this.validator.message(
                                          "CAM Deposit Nature",
                                          values.cdepLogic.camDepositNature,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  {values.cdepLogic.camDepositNature !== "" && (
                                    <>
                                      <div className="newGridSectionInner">
                                        <label>
                                          Period
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="text"
                                            name="cdepLogic.period"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.period}
                                            onChange={(e) => {
                                              this.state.period = e.target.value;
                                            }}
                                          />
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          Period Term
                                        </label>
                                        <div className="position-relative">
                                          <div className="row m-0">
                                            <div className="col-sm-4 p-0">
                                              <Field
                                                type="text"
                                                name="periodTermmYY"
                                                placeholder="YY"
                                                className="centerPlaceHolder"
                                                disabled={this.state.disableOnEdit}
                                                value={this.state.periodTermYY}
                                                onChange={(e) => {
                                                  this.state.periodTermYY = e.target.value;
                                                  handleChange(e);
                                                }}
                                                onBlur={(e) => {
                                                  this.calculateToDate(e);
                                                }}
                                              />

                                            </div>
                                            <div className="col-sm-4">
                                              <Field
                                                type="text"
                                                name="periodTermMM"
                                                placeholder="MM"
                                                className="centerPlaceHolder"
                                                disabled={this.state.disableOnEdit}
                                                value={this.state.periodTermMM}
                                                onChange={(e) => {
                                                  this.state.periodTermMM = e.target.value;
                                                  handleChange(e);
                                                }}
                                                onBlur={(e) => {
                                                  this.calculateToDate(e);
                                                }}
                                              />

                                            </div>
                                            <div className="col-sm-4 p-0">
                                              <Field
                                                type="text"
                                                name="periodTermDD"
                                                placeholder="DD"
                                                className="centerPlaceHolder"
                                                disabled={this.state.disableOnEdit}
                                                value={this.state.periodTermDD}
                                                onChange={(e) => {
                                                  this.state.periodTermDD = e.target.value;
                                                  handleChange(e);
                                                }}
                                                onBlur={(e) => {
                                                  this.calculateToDate(e);
                                                }}
                                              />

                                            </div>
                                          </div>
                                          <ErrorMessage
                                            name="mfLogic.periodTerm"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="date"
                                            readOnly={this.state.readOnEdit}
                                            name="cdepLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="date"
                                            readOnly={this.state.readOnEdit}
                                            name="cdepLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          CDEP # Months
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="text"
                                            name="cdepLogic.months"
                                          />
                                          <ErrorMessage
                                            name="cdepLogic.months"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          CDEP Rate UOM <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="cdepLogic.rateUOM"
                                            onChange={(e) => {
                                              this.validator = new SimpleReactValidator({
                                                autoForceUpdate: this,
                                              });
                                              values.cdepLogic.rateUOM = e.target.value;
                                              handleChange(e);
                                              this.calculateCdepAmount(values, setFieldValue);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Flat Amount" label="Flat Amount" />
                                            <option value="Per Sq Ft" label="Per Sq Ft" />
                                          </Field>
                                          {this.validator.message(
                                            "CDEP Rate UOM",
                                            values.cdepLogic.rateUOM,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      {values.cdepLogic.rateUOM === "Per Sq Ft" && (
                                        <div className="newGridSectionInner">
                                          <label>
                                            CDEP On Area
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name="cdepLogic.onArea"
                                              onChange={(e) => {
                                                handleChange(e);
                                                values.cdepLogic.onArea = e.target.value;
                                                this.calculateCdepAmount(values, setFieldValue);
                                              }}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Usable Area" label="Usable Area" />
                                              <option value="Carpet Area" label="Carpet Area" />
                                              <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                            </Field>
                                            {this.validator.message(
                                              "On Area",
                                              values.cdepLogic.onArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      {typeof this.state.camDepositDetails[values.cdepLogic.camDepositNature] !== "undefined" &&
                                        this.state.camDepositDetails[values.cdepLogic.camDepositNature].length > 0 &&
                                        this.state.camDepositDetails[values.cdepLogic.camDepositNature][this.state.camDepositDetails[values.cdepLogic.camDepositNature].length - 1]['rate'] !== 0 && (
                                          <div className="newGridSectionInner">
                                            <label>
                                              Escalation %
                                            </label>
                                            <div className="position-relative">
                                              <Field
                                                type="number"
                                                name="cdepLogic.escalationPercent"
                                                onBlur={(e) => {
                                                  this.calculateRentRate(e, values, setFieldValue);
                                                }}
                                              />
                                              {this.validator.message(
                                                "Escalation %",
                                                values.cdepLogic.escalationPercent,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        )}

                                      <div className="newGridSectionInner">
                                        <label>
                                          CDEP # Rate
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="cdepLogic.rate"
                                            onBlur={(e) => {
                                              this.calculateCdepAmount(values, setFieldValue);
                                              if (this.state.period > 1) {
                                                this.calculateMilestoneAmount(e, values, 0);
                                              }
                                            }}
                                          />
                                          {this.validator.message(
                                            "CDEP Rate",
                                            values.cdepLogic.rate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          CDEP Total Amount
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="text"
                                            name="cdepLogic.totalAmount"
                                          />
                                          <ErrorMessage
                                            name="cdepLogic.totalAmount"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          CDEP Milestones Count
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="text"
                                            name="cdepLogic.milestonesCount"
                                            value={this.state.period === 1 ? this.state.milestonesCount : 1}
                                            readOnly={this.state.period !== 1}
                                            onChange={(e) => {
                                              if (!isNaN(e.target.value)) {
                                                this.setState({
                                                  milestonesCount: e.target.value,
                                                });
                                              }
                                            }}
                                          />
                                          <ErrorMessage
                                            name="cdepLogic.milestonesCount"
                                            component="div"
                                            className="text-red"
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </>
                              )}

                              {values.cdepLogic.camDepositNature !== "" && (
                                <div className="gridColOneByThree depositNature">
                                  {this.state.showForm && (
                                    <div className="unitFormContainerNew rentButtons">
                                      {this.milestoneTabs(handleChange, values)}
                                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                        <button
                                          className="add_button"
                                          type="button"
                                          onClick={(e) => {
                                            console.log(values, "nn");
                                            this.addDetails(values, resetForm);
                                          }}
                                        >
                                          Add
                                        </button>
                                        <button
                                          className="reset_button"
                                          type="reset"
                                          onClick={(e) => {
                                            console.log(values, "nn");
                                            this.resetDetails(values, resetForm);
                                          }}
                                        >
                                          Reset
                                        </button>
                                      </div>

                                    </div>
                                  )}
                                </div>
                              )}
                            </>
                          )}
                          <div className="gridColOneByThree">
                            <span className="remarks">Notes/Remarks</span>
                            <Field as="textarea" className="notes mb-3" name="notes_12" />
                          </div>
                        </div>
                        {this.mainFormValidator.message(
                          "CAM Deposit Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">CAM Deposit Details</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col" colSpan="2">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(this.state.camDepositDetails).map(
                                function (key, index1) {
                                  return this.state.camDepositDetails[key].map(
                                    function (name, index) {
                                      return (
                                        <tr key={"mfTable" + index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            <a
                                              className="popupLink"
                                              onClick={(e) => {
                                                this.state.popupData = name;
                                                this.openModal();
                                              }}
                                            >
                                              {name.period}
                                            </a>
                                          </td>
                                          <td>
                                            {name.periodTermYY == ""
                                              ? "0"
                                              : name.periodTermYY}
                                            {"-"}
                                            {name.periodTermMM == ""
                                              ? "0"
                                              : name.periodTermMM}
                                            {"-"}
                                            {name.periodTermDD == ""
                                              ? "0"
                                              : name.periodTermDD}
                                          </td>
                                          <td>
                                            {" "}
                                            {/* {dateFormat(
                                            name.fromDate,
                                            "dd mmm yyyy"
                                          )} */}
                                            {leaseDateFormat(name.fromDate)}
                                          </td>
                                          <td>
                                            {/* {dateFormat(
                                            name.toDate,
                                            "dd mmm yyyy"
                                          )} */}
                                            {leaseDateFormat(name.toDate)}
                                          </td>
                                          <td>{name.camDepositNature}</td>
                                          <td>{ formatTwoDecimal(name.totalAmount) || "-"}</td>
                                          <td>
                                            {/* <button
                                            type="button"
                                            className="tableActionEdit rentalEdit"
                                            onClick={(e) => {
                                              this.editCd(index, values, key);
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faPen} />
                                          </button> */}
                                            {this.state.camDepositDetails[key]
                                              .length ==
                                              index + 1 && (
                                                <button
                                                  type="button"
                                                  className="actionDelete rentalDeleteButton"
                                                  onClick={(e) => {
                                                    // if (
                                                    //   window.confirm(
                                                    //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                                    //   )
                                                    // ) {
                                                    //   var _cdd =
                                                    //     this.state
                                                    //       .camDepositDetails;
                                                    //   _cdd[key].splice(index, 1);
                                                    //   this.setState({
                                                    //     camDepositDetails: _cdd,
                                                    //     showForm: true,
                                                    //   });
                                                    //   this.state.period--;
                                                    // }
                                                    this.setState({
                                                      delete: true,
                                                      index_val: index,
                                                      keyvalue: key,
                                                    });
                                                  }}
                                                >
                                                  <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                              )}
                                          </td>
                                        </tr>
                                      );
                                    },
                                    this
                                  );
                                },
                                this
                              )}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                  {/* <div className="unitFormContainerNew p-0 m-0">
                    <Form className="customTabs">
                      <div className="newGridSectionParent">
                        {this.state.showForm && (
                          <div className="unitFormContainerNew leaseSection mb-3">
                            <div className="row m-0">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Lease Term (YY-MM-DD){" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-3 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermYY}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermMM}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        value={this.state.leaseTermDD}
                                      />
                                    </div>
                                    <ErrorMessage
                                      name="leaseTerm"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Lease Renewal Term (YY-MM-DD){" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-3 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermYY"
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermYY}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermMM"
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermMM}
                                      />
                                    </div>
                                    <div className="col-sm-2 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name="leaseRenewalTermDD"
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        value={this.state.renewalLeaseTermDD}
                                      />
                                    </div>
                                    <ErrorMessage
                                      name="leaseRenewalTerm"
                                      component="div"
                                      className="text-red"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row m-0">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      From
                                    </label>
                                    <div className="col-sm-7">
                                      <Field type="date" name="from" />
                                      <ErrorMessage
                                        name="from"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      To
                                    </label>
                                    <div className="col-sm-7">
                                      <Field type="date" name="to" />
                                      <ErrorMessage
                                        name="to"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      CAM Deposit Applicable{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7">
                                      <Field
                                        as="select"
                                        name={"camDepositApplicable"}
                                        value={this.state.applicableValue}
                                        onChange={(e) => {
                                          this.state.applicableValue =
                                            e.target.value;
                                          this.showCdForm(e);
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="yes" label="Yes" />
                                        <option value="no" label="No" />
                                      </Field>
                                      {this.applicableValidator.message(
                                        "CAM Deposit Applicable",
                                        this.state.applicableValue,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>



                            {this.state.toggleCdForm && (
                              <div className="cdApplicable">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Deposit Nature (CDEP)
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"cdepLogic.camDepositNature"}
                                            disabled={this.state.disableOnEdit}
                                            onChange={(e) => {
                                              if (
                                                this.getDepositNature(
                                                  e,
                                                  values,
                                                  setFieldValue
                                                )
                                              ) {
                                                handleChange(e);
                                              }
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Refundable - Interest Free"
                                              label="Refundable - Interest Free"
                                            />
                                            <option
                                              value="Refundable - Interest Bearing"
                                              label="Refundable - Interest Bearing"
                                            />
                                            <option
                                              value="Non Refundable - Interest Free"
                                              label="Non Refundable - Interest Free"
                                            />
                                            <option
                                              value="Non Refundable - Interest Bearing"
                                              label="Non Refundable - Interest Bearing"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "CAM Deposit Nature",
                                            values.cdepLogic.camDepositNature,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {values.cdepLogic.camDepositNature !== "" && (
                                  <div className="depositNature">
                                    <div className="row m-0">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Period
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="text"
                                                name="cdepLogic.period"
                                                disabled={this.state.disableOnEdit}
                                                value={this.state.period}
                                                onChange={(e) => {
                                                  this.state.period =
                                                    e.target.value;
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Period Term
                                            </label>
                                            <div className="col-sm-3 leaseTermFieldWidth">
                                              <Field
                                                type="text"
                                                name="periodTermmYY"
                                                placeholder="YY"
                                                className="centerPlaceHolder"
                                                disabled={this.state.disableOnEdit}
                                                value={this.state.periodTermYY}
                                                onChange={(e) => {
                                                  this.state.periodTermYY =
                                                    e.target.value;
                                                  handleChange(e);
                                                }}
                                                onBlur={(e) => {
                                                  this.calculateToDate(e);
                                                }}
                                              />
                                            </div>
                                            <div className="col-sm-2 leaseTermFieldWidth">
                                              <Field
                                                type="text"
                                                name="periodTermMM"
                                                placeholder="MM"
                                                className="centerPlaceHolder"
                                                disabled={this.state.disableOnEdit}
                                                value={this.state.periodTermMM}
                                                onChange={(e) => {
                                                  this.state.periodTermMM =
                                                    e.target.value;
                                                  handleChange(e);
                                                }}
                                                onBlur={(e) => {
                                                  this.calculateToDate(e);
                                                }}
                                              />
                                            </div>
                                            <div className="col-sm-2 leaseTermFieldWidth">
                                              <Field
                                                type="text"
                                                name="periodTermDD"
                                                placeholder="DD"
                                                className="centerPlaceHolder"
                                                disabled={this.state.disableOnEdit}
                                                value={this.state.periodTermDD}
                                                onChange={(e) => {
                                                  this.state.periodTermDD =
                                                    e.target.value;
                                                  handleChange(e);
                                                }}
                                                onBlur={(e) => {
                                                  this.calculateToDate(e);
                                                }}
                                              />
                                            </div>
                                            <ErrorMessage
                                              name="mfLogic.periodTerm"
                                              component="div"
                                              className="text-red"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row m-0">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              From <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="date"
                                                readOnly={this.state.readOnEdit}
                                                name="cdepLogic.fromDate"
                                                value={this.state.fromDate}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                              />
                                              {this.validator.message(
                                                "From",
                                                this.state.fromDate,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              To <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="date"
                                                readOnly={this.state.readOnEdit}
                                                name="cdepLogic.toDate"
                                                value={this.state.toDate}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                              />
                                              {this.validator.message(
                                                "To",
                                                this.state.toDate,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CDEP # Months
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="text"
                                                name="cdepLogic.months"
                                              />
                                              <ErrorMessage
                                                name="cdepLogic.months"
                                                component="div"
                                                className="text-red"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CDEP Rate UOM
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                as="select"
                                                name={"cdepLogic.rateUOM"}
                                                onChange={(e) => {
                                                  this.validator =
                                                    new SimpleReactValidator({
                                                      autoForceUpdate: this,
                                                    });
                                                  values.cdepLogic.rateUOM =
                                                    e.target.value;
                                                  handleChange(e);
                                                  this.calculateCdepAmount(
                                                    values,
                                                    setFieldValue
                                                  );
                                                }}
                                              >
                                                <option
                                                  value=""
                                                  label="Select"
                                                  defaultValue
                                                />
                                                <option
                                                  value="Flat Amount"
                                                  label="Flat Amount"
                                                />
                                                <option
                                                  value="Per Sq Ft"
                                                  label="Per Sq Ft"
                                                />
                                              </Field>
                                              {this.validator.message(
                                                "CDEP Rate UOM",
                                                values.cdepLogic.rateUOM,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {values.cdepLogic.rateUOM == "Per Sq Ft" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                CDEP On Area
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={"cdepLogic.onArea"}
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                    values.cdepLogic.onArea =
                                                      e.target.value;
                                                    this.calculateCdepAmount(
                                                      values,
                                                      setFieldValue
                                                    );
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  <option
                                                    value="Usable Area"
                                                    label="Usable Area"
                                                  />
                                                  <option
                                                    value="Carpet Area"
                                                    label="Carpet Area"
                                                  />
                                                  <option
                                                    value="Gross Leasable Area"
                                                    label="Gross Leasable Area"
                                                  />
                                                </Field>
                                                {this.validator.message(
                                                  "On Area",
                                                  values.cdepLogic.onArea,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {
                                        typeof this.state.camDepositDetails[values.cdepLogic.camDepositNature] != "undefined" && this.state.camDepositDetails[values.cdepLogic.camDepositNature].length > 0 && this.state.camDepositDetails[values.cdepLogic.camDepositNature][this.state.camDepositDetails[values.cdepLogic.camDepositNature].length - 1]['rate'] != 0 && (
                                          <div className="col-lg-6">
                                            <div className="inputContainer col-lg-12 col-md-12">
                                              <div className="row mb-3">
                                                <label className="col-sm-4 col-form-label">
                                                  Escalation %
                                                </label>
                                                <div className="col-sm-7">
                                                  <Field
                                                    type="number"
                                                    name="cdepLogic.escalationPercent"
                                                    //disabled={this.state.disableOnEdit}
                                                    onBlur={(e) => {
                                                      this.calculateRentRate(
                                                        e,
                                                        values,
                                                        setFieldValue
                                                      );
                                                    }}
                                                  />
                                                  {this.validator.message(
                                                    "Escalation %",
                                                    values.cdepLogic.escalationPercent,
                                                    "required",
                                                    { className: "text-danger" }
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      }
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CDEP # Rate
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="number"
                                                name="cdepLogic.rate"
                                                onBlur={(e) => {
                                                  this.calculateCdepAmount(
                                                    values,
                                                    setFieldValue
                                                  );
                                                  if (this.state.period > 1) {
                                                    this.calculateMilestoneAmount(
                                                      e,
                                                      values,
                                                      0
                                                    );
                                                  }
                                                }}
                                              />
                                              {this.validator.message(
                                                "CDEP Rate",
                                                values.cdepLogic.rate,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CDEP Total Amount
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="text"
                                                name="cdepLogic.totalAmount"
                                              />
                                              <ErrorMessage
                                                name="cdepLogic.totalAmount"
                                                component="div"
                                                className="text-red"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row m-0">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CDEP Milestones Count
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="text"
                                                name="cdepLogic.milestonesCount"
                                                value={
                                                  this.state.period === 1
                                                    ? this.state.milestonesCount
                                                    : 1
                                                }
                                                readOnly={
                                                  this.state.period === 1
                                                    ? false
                                                    : true
                                                }
                                                onChange={(e) => {
                                                  if (!isNaN(e.target.value)) {
                                                    this.setState({
                                                      milestonesCount:
                                                        e.target.value,
                                                    });
                                                  }
                                                }}
                                              />
                                              <ErrorMessage
                                                name="cdepLogic.milestonesCount"
                                                component="div"
                                                className="text-red"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {values.cdepLogic.camDepositNature !== "" && (
                          <div className="depositNature">
                            {this.state.showForm && (
                              <div className="unitFormContainerNew rentButtons">
                                {this.milestoneTabs(handleChange, values)}
                                <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                  <button
                                    className="add_button"
                                    type="button"
                                    onClick={(e) => {
                                      console.log(values, "nn");
                                      this.addDetails(values, resetForm);
                                    }}
                                  >
                                    Add
                                  </button>
                                  <button
                                    className="reset_button"
                                    type="reset"
                                    onClick={(e) => {
                                      console.log(values, "nn");
                                      this.resetDetails(values, resetForm);
                                    }}
                                  >
                                    Reset
                                  </button>
                                </div>

                              </div>
                            )}
                          </div>
                        )}
                        <div className="unitFormContainerNew">
                          <span className="remarks">Notes/Remarks</span>
                          <Field as="textarea" className="notes mb-3" name="notes_12" />
                        </div>
                        {this.mainFormValidator.message(
                          "CAM Deposit Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">CAM Deposit Details</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col" colSpan="2">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(this.state.camDepositDetails).map(
                                function (key, index1) {
                                  return this.state.camDepositDetails[key].map(
                                    function (name, index) {
                                      return (
                                        <tr key={"mfTable" + index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            <a
                                              className="popupLink"
                                              onClick={(e) => {
                                                this.state.popupData = name;
                                                this.openModal();
                                              }}
                                            >
                                              {name.period}
                                            </a>
                                          </td>
                                          <td>
                                            {name.periodTermYY == ""
                                              ? "0"
                                              : name.periodTermYY}
                                            {"-"}
                                            {name.periodTermMM == ""
                                              ? "0"
                                              : name.periodTermMM}
                                            {"-"}
                                            {name.periodTermDD == ""
                                              ? "0"
                                              : name.periodTermDD}
                                          </td>
                                          <td>
                                            {" "}
                                            {leaseDateFormat(name.fromDate)}
                                          </td>
                                          <td>
                                            {leaseDateFormat(name.toDate)}
                                          </td>
                                          <td>{name.camDepositNature}</td>
                                          <td>{name.totalAmount || "-"}</td>
                                          <td>
                                            {this.state.camDepositDetails[key]
                                              .length ==
                                              index + 1 && (
                                                <button
                                                  type="button"
                                                  className="actionDelete rentalDeleteButton"
                                                  onClick={(e) => {
                                                    // if (
                                                    //   window.confirm(
                                                    //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                                    //   )
                                                    // ) {
                                                    //   var _cdd =
                                                    //     this.state
                                                    //       .camDepositDetails;
                                                    //   _cdd[key].splice(index, 1);
                                                    //   this.setState({
                                                    //     camDepositDetails: _cdd,
                                                    //     showForm: true,
                                                    //   });
                                                    //   this.state.period--;
                                                    // }
                                                    this.setState({
                                                      delete: true,
                                                      index_val: index,
                                                      keyvalue: key,
                                                    });
                                                  }}
                                                >
                                                  <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                              )}
                                          </td>
                                        </tr>
                                      );
                                    },
                                    this
                                  );
                                },
                                this
                              )}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div> */}
                </>
              )}
            </Formik>
          </div>
        </div>
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row m-0">
                        <div className="col-lg-12">
                          <ul>
                            <li>Cam Deposit Details</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isOpen &&
                    this.camDepositDetailPopup(this.state.popupData)}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div>
    );
  }
  camDepositDetailPopup(cam) {
    console.log(cam);
    return this.camDetailsPopup(cam);
  }
  camDetailsPopup(cam) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.periodTermYY == "" ? "0" : cam.periodTermYY}
                  {"-"}
                  {cam.periodTermMM == "" ? "0" : cam.periodTermMM}
                  {"-"}
                  {cam.periodTermDD == "" ? "0" : cam.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Cam Deposit Nature (RDEP) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.camDepositNature}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {/* {dateFormat(cam.fromDate, "dd mmm yyyy")} */}
                  {leaseDateFormat(cam.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {/* {dateFormat(cam.toDate, "dd mmm yyyy")} */}
                  {leaseDateFormat(cam.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CDEP # Months <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.months}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CDEP Rate UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.rateUOM}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CDEP # Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.rate}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CDEP On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{cam.onArea}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  CDEP Total Amount <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {cam.totalAmount}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  CDEP MileStones
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer p-0">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">Milestone Name</th>
                          <th scope="col">Due Date</th>
                          <th scope="col">RDEP Milestone</th>
                          <th scope="col">RDEP Milestone Amount (Rs.)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cam.milestones.length > 0 &&
                          cam.milestones.map((name, index) => (
                            <tr key={index}>
                              <td>{name.milestoneName}</td>
                              <td>
                                {/* {dateFormat(name.dueDate, "dd mmm yyyy")} */}
                                {leaseDateFormat(name.dueDate)}
                              </td>
                              <td>
                                {name.milestonePercent}
                                {name.milestoneType == "CDEP Months"
                                  ? " Months"
                                  : " %"}
                              </td>
                              <td>{name.amount}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(CAMDepositDetails);
